import { createActions, handleActions } from 'redux-actions';

const initState = {
  summaryData: [],
  detailData: [],
  fetching: false,
  error: null,
};

export const creators = createActions({
  PROJECTPERFORMANCE_SUMMARY_REQUEST: (selectedYear, DateKey) => ({
    selectedYear,
    DateKey,
  }),
  PROJECTPERFORMANCE_DETAIL_REQUEST: (selectedYear, DateKey) => ({
    selectedYear,
    DateKey,
  }),
  PROJECTPERFORMANCE_SUCCESS: (payload) => payload,
  PROJECTPERFORMANCE_FAILURE: (payload) => payload,
});

const summaryReducer = (state) => {
  return { ...state, fetching: true, error: null };
};

const detailReducer = (state) => {
  return { ...state, fetching: true, error: null };
};

const successReducer = (state, { payload }) => {
  const nextState = Object.assign({}, state, payload);
  nextState.fetching = false;
  return nextState;
};

const failureReducer = (state, { payload }) => {
  return { ...state, fetching: false, error: payload };
};

export default handleActions(
  {
    PROJECTPERFORMANCE_SUMMARY_REQUEST: summaryReducer,
    PROJECTPERFORMANCE_DETAIL_REQUEST: detailReducer,
    PROJECTPERFORMANCE_SUCCESS: successReducer,
    PROJECTPERFORMANCE_FAILURE: failureReducer,
  },
  initState,
);
